export default {
  totalEnrollmentsData: []
}
